import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    let attempts = 0;
    const timer = setInterval(async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/stripe-status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState("paid");
          clearInterval(timer);
        }
      } catch {}
      if (attempts >= 12) {
        setState((s) => (s === "paid" ? s : "failed"));
        clearInterval(timer);
      }
    }, 2000);
    return () => clearInterval(timer);
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-24" data-testid="payment-success-page">
      <div className="max-w-md w-full backdrop-blur-xl bg-[#101C3E]/70 border border-[#d4af37]/30 p-10 text-center">
        {state === "checking" && (
          <>
            <Loader2 size={36} className="animate-spin text-[#d4af37] mx-auto mb-6" />
            <h1 className="font-display text-3xl font-light text-slate-50">Confirming your payment…</h1>
            <p className="text-slate-400 text-sm mt-3">This takes just a few seconds.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle2 size={40} className="text-[#d4af37] mx-auto mb-6" />
            <h1 className="font-display text-3xl font-light text-slate-50" data-testid="payment-paid-title">
              Advance <span className="italic text-[#d4af37]">received.</span>
            </h1>
            <p className="text-slate-400 text-sm mt-4 leading-relaxed">
              Thank you — your booking advance is confirmed. Our team will call or WhatsApp you shortly
              to finalise your journey.
            </p>
          </>
        )}
        {state === "failed" && (
          <>
            <XCircle size={40} className="text-red-400 mx-auto mb-6" />
            <h1 className="font-display text-3xl font-light text-slate-50">Couldn't confirm yet.</h1>
            <p className="text-slate-400 text-sm mt-4 leading-relaxed">
              If your card was charged, don't worry — message us on WhatsApp and we'll verify it manually.
            </p>
          </>
        )}
        <Link
          to="/"
          data-testid="payment-home-link"
          className="inline-block mt-8 border border-[#d4af37] text-[#d4af37] px-8 py-3 text-xs tracking-[0.15em] uppercase hover:bg-[#d4af37] hover:text-[#0A1128] transition-colors"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
